module.exports = __webpack_public_path__ + "img/auth-logo.ec748987.png";